<template>
	<div>
		<b-form inline>
			<b-input-group prepend="Couleur">
				<b-select v-model="color" :options="['non', 'oui']"></b-select>
			</b-input-group>
			<b-input-group prepend="Image">
				<b-select
					v-model="view_image"
					:options="['non', 'oui']"></b-select>
			</b-input-group>
			<b-input-group prepend="Texte">
				<b-select
					v-model="view_text"
					:options="['non', 'oui']"></b-select>
			</b-input-group>
			<b-input-group prepend="Document">
				<b-select
					v-model="document_name"
					:options="documents_name"></b-select>
			</b-input-group>
			<b-input-group prepend="Page">
				<b-select
					v-model="document_page"
					:options="documents_page"></b-select>
			</b-input-group>
			<b-input-group
				v-show="zones_extract_list.length > 1"
				prepend="Visualiser">
				<b-select
					v-model="zone_extract"
					:options="zones_extract_list"></b-select>
			</b-input-group>
		</b-form>
		<br />
		<b-container
			style="
				margin: 0px !important;
				padding: 0px !important;
				max-width: none !important;
			">
			<b-row>
				<b-col cols="8">
					<div ref="panzoomElem">
						<panZoom
							selector=".movable"
							style="border: 1px solid; overflow: hidden"
							:options="{
								initialZoom: 1,
								bounds: false,
							}"
							@init="onInit">
							<div
								style="height: 500px; width: 2000px"
								@mousemove="handler_move($event)"
								@mouseup.right="handler_up($event)"
								@mousedown.right="handler($event)"
								@contextmenu.prevent>
								<div class="movable">
									<img
										v-if="image && view_image == 'oui'"
										:src="
											'data:image/png;base64,' + image
										" /><img />
									<div
										v-if="zone_extract"
										:style="
											'position:fixed; top:' +
											zones_extract[zone_extract]
												.position_absolute.top +
											'px; left:' +
											zones_extract[zone_extract]
												.position_absolute.left +
											'px; width: ' +
											zones_extract[zone_extract]
												.position_absolute.width +
											'px; height: ' +
											zones_extract[zone_extract]
												.position_absolute.height +
											'px; background-color: red; opacity:0.25'
										"></div>
									<div
										v-if="zone && zone.position && (zone.parameters.options.condition_page == '' || parseInt(zone.parameters.options.condition_page) == parseInt(page_obj.current_page)) && ((!zone.parameters.options.condition_rotation && zone.parameters.options.condition_rotation != 0) || parseInt(zone.parameters.options.condition_rotation) == page_obj.rotate)"
										:style="
											'position:fixed; top:' +
											zone.position.top +
											'px; left:' +
											zone.position.left +
											'px; width: ' +
											zone.position.width +
											'px; height: ' +
											zone.position.height +
											'px; background-color: blue; opacity:0.25'
										"></div>
									<div
										v-if="zone && zone.position_parent && (zone.parameters.options.condition_page == '' || parseInt(zone.parameters.options.condition_page) == parseInt(page_obj.current_page)) && ((!zone.parameters.options.condition_rotation && zone.parameters.options.condition_rotation != 0) || parseInt(zone.parameters.options.condition_rotation) == page_obj.rotate)"
										:style="
											'position:fixed; top:' +
											zone.position_parent.top +
											'px; left:' +
											zone.position_parent.left +
											'px; width: ' +
											zone.position_parent.width +
											'px; height: ' +
											zone.position_parent.height +
											'px; background-color: blue; opacity:0.10'
										"></div>
									<div
										:style="
											'position:fixed; top:' +
											abs_y +
											'px; left:' +
											(abs_x - 5) +
											'px; height: 1px; width: 11px; background-color: red;'
										"></div>
									<div
										:style="
											'position:fixed; top:' +
											(abs_y - 5) +
											'px; left:' +
											abs_x +
											'px; height: 11px; width: 1px; background-color: red;'
										"></div>
									<div v-if="view_text == 'oui'">
										<div
											:id="i"
											v-html="
												item.html /*.replace(/-/g, '&#8209;')*/
											"
											v-for="(item, i) in items"
											:key="i"
											:style="
												'position:fixed;' +
												'top:' +
												item.position.top +
												'px;' +
												'bottom:' +
												item.position.bottom +
												'px;' +
												'left:' +
												item.position.left +
												'px;' +
												'right:' +
												item.position.right +
												'px;' +
												'height:' +
												(item.position.bottom -
													item.position.top) +
												'px;' +
												'width:' +
												(item.position.right -
													item.position.left) +
												'px;' +
												'font-size:' +
												(styles[item.style]
													? styles[item.style][
															'font-size'
													  ]
													: 10) +
												'px;' +
												'color:' +
												(color == 'oui'
													? styles[item.style]
														? styles[item.style][
																'font-color'
														  ]
														: 'black'
													: 'black') +
												';white-space: nowrap;'
											"
											@mouseenter="addClass"
											@mouseleave="removeClass"></div>
									</div>
									<div v-if="move">
										<div v-if="actual_x > x">
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_x +
													'px; width: ' +
													(abs_actual_x - abs_x) +
													'px; height: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_x +
													'px; width: ' +
													(abs_actual_x - abs_x) +
													'px; height: 2px; background-color: black;'
												"></div>
										</div>
										<div v-else>
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_actual_x +
													'px; width: ' +
													(abs_x - abs_actual_x) +
													'px; height: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_actual_x +
													'px; width: ' +
													(abs_x - abs_actual_x) +
													'px; height: 2px; background-color: black;'
												"></div>
										</div>
										<div v-if="actual_y > y">
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_x +
													'px; height: ' +
													(abs_actual_y - abs_y) +
													'px; width: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_y +
													'px; left:' +
													abs_actual_x +
													'px; height: ' +
													(abs_actual_y - abs_y) +
													'px; width: 2px; background-color: black;'
												"></div>
										</div>
										<div v-else>
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_x +
													'px; height: ' +
													(abs_y - abs_actual_y) +
													'px; width: 2px; background-color: black;'
												"></div>
											<div
												:style="
													'position:fixed; top:' +
													abs_actual_y +
													'px; left:' +
													abs_actual_x +
													'px; height: ' +
													(abs_y - abs_actual_y) +
													'px; width: 2px; background-color: black;'
												"></div>
										</div>
									</div>
								</div>
							</div>
						</panZoom>
					</div>
				</b-col>
				<b-col cols="4">
					<b-button @click="reset">Recadrer la vue</b-button>
					<h3>Zone</h3>
					<b-form inline>
						<b-input
							v-model="name_zone"
							@change="update_name"></b-input>
						<b-button @click="addZone()"
							><i class="fas fa-plus"></i
						></b-button>
					</b-form>
					<h3>Coordonnées</h3>
					<b-form-checkbox v-model="relative"
						>Positions relatives</b-form-checkbox
					>
					<div>
						Coordonnées actuelles<br />
						X : {{ actual_x }} - Y : {{ actual_y }}
					</div>
					<div>
						Coordonnées ciblées<br />
						X : {{ x }} - Y : {{ y }}
					</div>
					<div>
						<b-dropdown
							variant="primary"
							split
							text="Les coordonnées sont par rapport à la zone"
							class="m-2"
							@click.prevent=""
							href="#">
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: '',
										limit_y: 'En dessous',
									})
								"
								variant="link"
								>La limite haute</b-dropdown-item
							>
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: '',
										limit_y: 'Au dessus',
									})
								"
								variant="link"
								>La limite basse</b-dropdown-item
							>
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: 'A droite',
										limit_y: '',
									})
								"
								variant="link"
								>La limite gauche</b-dropdown-item
							>
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: 'A gauche',
										limit_y: '',
									})
								"
								variant="link"
								>La limite droite</b-dropdown-item
							>
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: 'A droite',
										limit_y: 'En dessous',
									})
								"
								variant="link"
								>Le coin supérieur gauche</b-dropdown-item
							>
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: 'A gauche',
										limit_y: 'En dessous',
									})
								"
								variant="link"
								>Le coin supérieur droit</b-dropdown-item
							>
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: 'A droite',
										limit_y: 'Au dessus',
									})
								"
								variant="link"
								>Le coin inféieur gauche</b-dropdown-item
							>
							<b-dropdown-item
								@click="
									addLimit({
										type: 'coordinates',
										relative: this.relative,
										x: x,
										y: y,
										limit_x: 'A gauche',
										limit_y: 'Au dessus',
									})
								"
								variant="link"
								>Le coin inférieur droit</b-dropdown-item
							>
						</b-dropdown>
					</div>
					<div v-if="item">
						<h3>Zone de texte</h3>
						<div>
							<b-button
								variant="link"
								@click="
									addLimit({
										type: 'zone_text_limit',
										search: [
											{
												value: item.text,
												type_search: 'Contient',
												type: 'texte',
											},
										],
										required: false,
										limit_x: '',
										limit_y: '',
										position: 'Premier',
									})
								"
								><i class="fas fa-plus"></i></b-button
							>Texte
						</div>
						<pre v-b-tooltip.hover :title="item.text">{{
							item.text.substring(0, 30) +
							(item.text
								? item.text.length > 30
									? "..."
									: ""
								: "")
						}}</pre>
						<div>
							<b-button
								variant="link"
								@click="
									addLimit({
										type: 'zone_text_limit',
										search: [
											{
												value: item.html,
												type_search: 'Contient',
												type: 'html',
											},
										],
										required: false,
										limit_x: '',
										limit_y: '',
										position: 'Premier',
									})
								"
								><i class="fas fa-plus"></i></b-button
							>Html
						</div>
						<pre v-b-tooltip.hover :title="item.html">{{
							item.html.substring(0, 30) +
							(item.html
								? item.html.length > 30
									? "..."
									: ""
								: "")
						}}</pre>
						<div>
							<b-button
								variant="link"
								@click="
									addLimit({
										type: 'zone_text_limit',
										search: [
											{
												value: styles[item.style][
													'font-size'
												],
												type_search: 'Egal',
												type: 'size_text',
											},
										],
										required: false,
										limit_x: '',
										limit_y: '',
										position: 'Premier',
									})
								"
								><i class="fas fa-plus"></i></b-button
							>Taille :
							{{
								styles[item.style]
									? styles[item.style]["font-size"]
									: 10
							}}<br />
							<b-button
								variant="link"
								@click="
									addLimit({
										type: 'zone_text_limit',
										search: [
											{
												value: styles[item.style][
													'font-color'
												],
												type: 'color',
											},
										],
										required: false,
										limit_x: '',
										limit_y: '',
										position: 'Premier',
									})
								"
								><i class="fas fa-plus"></i></b-button
							>Couleur:
							{{
								styles[item.style]
									? styles[item.style]["font-color"]
									: "black"
							}}<br />
							<b-button
								variant="link"
								@click="
									addLimit({
										type: 'zone_text_limit',
										search: [
											{
												value: item.background_color,
												type: 'background_color',
											},
										],
										required: false,
										limit_x: '',
										limit_y: '',
										position: 'Premier',
									})
								"
								><i class="fas fa-plus"></i></b-button
							>Couleur de fond : {{ item.background_color }}
						</div>
						<b-button
							variant="link"
							@click="
								addLimit({
									type: 'zone_text_limit',
									search: [
										{
											value: item.text,
											type_search: 'Contient',
											type: 'texte',
										},
										{
											value: item.html,
											type_search: 'Contient',
											type: 'html',
										},
										{
											value: styles[item.style][
												'font-size'
											],
											type_search: 'Egal',
											type: 'size_text',
										},
										{
											value: styles[item.style][
												'font-color'
											],
											type: 'color',
										},
										{
											value: item.background_color,
											type: 'background_color',
										},
									],
									required: false,
									limit_x: '',
									limit_y: '',
									position: 'Premier',
								})
							"
							>Ajouter la zone de texte comme limite</b-button
						>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<br />
		<b-container v-show="tabIndex < 2" :style="'margin: 0; padding: 0; max-width: none;'">
			<b-row ref="div_row" style="margin: 0; padding: 0; max-width: none">
				<b-col ref="div_menu" md="auto" style="margin: 0; padding: 0; max-width: none">
					<div>
						Zones
						<i class="fas fa-plus-square" @click="addZone()"></i>
					</div>
					<document_extraction_tree
						:level="0"
						:zones="zones"
						:view="view_zones"
						@select="select"
						@add="addZone"></document_extraction_tree>
				</b-col>
				<b-col>
					<div v-for="(zone, idx) in zones" :key="zone.id">
						<div v-show="zone.id == view_zones">
							<document_extraction_zone
								:ref="'document_extraction_zone' + zone.id"
								:start_name="zone.load ? false : 'zone ' + idx"
								:projects="projects"
								:projects_options="projects_options"
								:results_arr="results_arr"
								:size="size"
								:scenario="scenario"
								@update="update(zone.id, ...arguments)">
							</document_extraction_zone>
							<i
								class="fa fa-times close"
								@click="removeAt(idx)"></i>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<b-tabs v-model="tabIndex">
			<b-tab title="Extraction">
				<p>Page</p>
				<b-button class="mb-2" @click="test">Test</b-button>
				<edit_tabulator
					:extern_file="false"
					ref="edit_tabulator"></edit_tabulator>
				<p>Fichier</p>
				<b-button class="mb-2" @click="test_file">Test fichier</b-button>
				<edit_tabulator
					:extern_file="false"
					ref="edit_tabulator_global"></edit_tabulator>
			</b-tab>
			<b-tab title="Post traitements">
				<br />
				<b-button class="mb-2" @click="test_post_treatment">Tester les post traitements</b-button>
				<edit_tabulator
					:extern_file="false"
					ref="edit_tabulator_post_t"></edit_tabulator>
				<div v-for="(log, idx) in post_treatment_logs.slice().reverse()" :key="idx">
					{{ log }}
				</div>
			</b-tab>
			<b-tab title="Mapping">
				<p>Colonnes : </p>

				<b-table striped hover :items="mapping_columns" :fields="[
					{
						key: 'colonne',
						label: 'Colonne',
						thStyle: { width: '15%' }
					},
					{
						key: 'mapping',
						label: 'Mapping',
						thStyle: { width: '15%' }
					},
					{
						key: 'exemple',
						label: 'Données récupérées',
						thStyle: { width: '30%' }
					},
					{
						key: 'text',
						label: 'Valeur',
						thStyle: { width: '30%' }
					},
					{
						key: 'index',
						label: '',
						thStyle: { width: '10%' }
					}
				]">
					<template v-slot:cell(mapping)="data">
						<b-input v-model="data.item.mapping" />
					</template>
					<template v-slot:cell(text)="data">
						<b-textarea v-model="data.item.text" />
					</template>
					<template #cell(index)="data">
						<i class="fa fa-times close" @click="remove_mapping(data.index)"></i>
					</template>
				</b-table>
				<b-button variant="link" @click="add_mapping"><i class="fas fa-plus"></i></b-button>
			</b-tab>
			<b-tab title="Colonnes supplémentaires">
				<div style="height:50vh; overflow-y:auto;">
					<div v-for="(column, idx) in columns" :key="idx">
						<b-card>
							<p>Colonne : <b-input class="col-sm-3" style="display:initial !important;" v-model="column.column" /></p>
							<p>Type : <b-select class="col-sm-3" style="display:initial !important;" :options="document_extraction" v-model="column.type_column" @change="change_type_column(idx)"></b-select></p>
							<p>Valeur : <span v-if="column.type && document_extraction_type[column.type]">{{column.value}}</span></p>
							<div v-if="column.type && document_extraction_type[column.type] && ( document_extraction_type[column.type].type == 'image' ||  document_extraction_type[column.type].type == 'sql')">
								<v-select :multiple="document_extraction_type[column.type].multiple ? true : false" v-model="column.value" :options="document_extraction_type[column.type].values" label="text" :reduce="option => option.value">
									<template slot="option" slot-scope="option">
										<div v-if="column.type && document_extraction_type[column.type].type == 'image'"> 
											<viewFile :showFileName="false" style="display: inline-block; ;max-width:300px; max-height:300px" :name="'image.png'" :data="option.text"></viewFile>&nbsp;<span>{{ option.value }}</span>
										</div>
										<div v-else>
											<div v-html="option.text"></div>
										</div>
									</template>
									<template slot="selected-option" slot-scope="option">
										<div v-if="option && option.text">
											<div v-if="column.type && document_extraction_type[column.type].type == 'image'"> 
												<viewFile :showFileName="false" style="width:100%;max-width:300px; max-height:300px" :name="'image.png'" :data="option.text"></viewFile>
											</div>
											<div v-else>
												<div v-html="option.text"></div>
											</div>
										</div>
										<div v-else>
											Sélectionner une valeur
										</div>
									</template>
								</v-select>
							</div>
							<div v-else-if="column.type && document_extraction_type[column.type] && document_extraction_type[column.type].type == 'document'">
								<documents_componenent :ref="'documents-' + idx" :select="true" :minimal="true" :view_files="true" :download="false" thd_class=" " @select_file="select_file($event,  column)"></documents_componenent>
							</div>
							<div v-else>
								<b-input v-model="column.value" />
							</div>
							<div style="text-align: end;">
								<i class="fa fa-times close" @click="remove_column(idx)"></i>
							</div>
						</b-card>
					</div>
					<b-button variant="link" v-b-toggle="'collapse-add-column' + id"><i class="fa fa-plus"></i></b-button>
					<b-collapse :id="'collapse-add-column' + id">
						<p>Colonne à ajouter</p>
						<b-select v-model="type_column" :options="document_extraction"></b-select>
						<br /><br />
						<b-button @click="add_column(null)">Ajouter</b-button>
					</b-collapse>
					<div style="height:500px"></div>
				</div>
			</b-tab>
			<b-tab title="Traitement complémentaire">
				<document_extraction_post_treatment 
					:ref="'document_extraction_post_treatment'"
					:projects="projects"
					:projects_options="projects_options"
					:scenario="scenario"
					:size="size"
				></document_extraction_post_treatment>
			</b-tab>
			<b-tab title="Test">
				<br />
				<b-button class="mb-2" @click="test_steps">Tester</b-button>
				<edit_tabulator
					:extern_file="false"
					ref="edit_tabulator_test"></edit_tabulator>
				<div v-for="(log, idx) in test_logs.slice().reverse()" :key="idx">
					{{ log }}
				</div>
			</b-tab>
		</b-tabs>
		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
	</div>
</template>

<script>
	import pdf from "vue-pdf";
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	
	import store from "../store";
	import scenario from '../services/scenario';
	import workers from "../services/workers.js";
	import documents_componenent from "../views/Document.vue";
	import viewFile from "../components/viewFile.vue";
	import treatments from "../services/treatments.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import document_extraction_zone from "../components/document_extraction_zone.vue";
	import document_extraction_tree from "../components/document_extraction_tree.vue";
	import document_extraction_post_treatment from "../components/document_extraction_post_treatment.vue";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	var clone = require("clone");

	export default {
		name: "document_extraction_page",
		components: {
			pdf,
			viewFile,
			draggable,
			FadeLoader,
			edit_tabulator,
			documents_componenent,
			document_extraction_zone,
			document_extraction_tree,
			document_extraction_post_treatment
		},
		props: {
			column_name: {
			},
			projects: {
				default: () => [],
			},
			projects_options: {
				default: () => [],
			},
			scenario: {},
			document_extraction: {
				default: () => []
			},
			document_extraction_type: {
				default: () => {}
			},
			inter_page: false
		},
		data() {
			return {
				id: uniqueId(""),
				size: 0,
				relative: false,
				move: false,
				name_zone: "",
				color: "oui",
				view_image: "oui",
				view_text: "oui",
				spinner: false,
				results: {},
				name: "",
				page: 0,
				url_pdf: "",
				url_image: "",
				image: "",
				panzoomInstance: null,
				items: [],
				styles: {},
				target: -1,
				item: null,
				x: 0,
				actual_x: 0,
				y: 0,
				actual_y: 0,
				abs_x: 0,
				abs_actual_x: 0,
				abs_y: 0,
				abs_actual_y: 0,
				e: null,
				zones: [
					{
						id: uniqueId(""),
						level: 0,
						zones: [],
					},
				],
				zone: null,
				view_zones: "",
				documents: {},
				documents_name: [],
				document_name: "",
				documents_page: [],
				document_page: "",

				zone_extract: "",
				zones_extract: {},
				zones_extract_list: [],

				results_arr: [],
				post_treatment_logs: [],
				columns: [],
				type_column: "",

				tabIndex: 0,

				mapping: false,
				mapping_columns: [],

				test_logs: [],
				rotate: 0,
				page_obj: {}
			};
		},
		watch: {
			mapping_columns: {
				deep: true,
				handler() {
					this.set_mapping_columns();
				}
			},
			columns: {
				deep: true,
				handler() {
					if (this.columns.length == 0)
					{
						this.scenario.deleteStepByDescription("columns");
					}
					else
					{
						var params = {
							"type": "line",
							"code": "",
							"strict": false,
							"cut_start": false,
							"cut_end": false
						};

						for (var i = 0; i < this.columns.length; i++)
						{
							params.code += "data[`" + this.columns[i].column + "`] = `" + this.columns[i].value + "`; \n"
						}

						if (!this.scenario.existStepByDescription("columns"))
						{
							this.scenario.addStep({
								"data": {
									"parameters": params,
									"action": "fonction",
									"label": "columns",
									"sql_rules": ""
								},
								"description": "columns",
								"action": "fonction",
								"actionLabel": "Script personnalisé",
								"c_conditions": true,
								"c_tree": false,
								"c_project": false,
								"project_id": "",
								"c_parameters": true,
								"c_tabulator": false,
								"c_test": true,
								"tabulator2": [],
								"keep_start_data": false,
								"option_delete": false,
								"option_make_list": false,
								"treatment": false,
								"source_data": "",
								"file_result": false,
								"currentRequest": null,
								"user_params": []
							}, null, ["Analyse pdf - ", "Post t - ", "Mapping", "modification_columns"]);
						}
						else
						{
							this.scenario.updateStepParametersByDescription("columns", params);
						}
					}
				}
			},
			view_zones: async function () {
				this.zone = null;
				for (var i = 0; i < this.zones.length; i++) {
					if (this.view_zones == this.zones[i].id) {
						this.zone = this.zones[i];
						break;
					}
				}
			},
			document_page: async function () {
				this.name = this.document_name;
				var keys = Object.keys(
					this.documents[this.document_name].pages
				);
				this.page = this.document_page - 1;
				this.items = [];

				this.page_obj = this.documents[this.document_name].pages[
						keys[this.document_page - 1]
					];
				var keys_items = Object.keys(
					this.documents[this.document_name].pages[
						keys[this.document_page - 1]
					].items
				);
				for (var i = 0; i < keys_items.length; i++) {
					var item =
						this.documents[this.document_name].pages[
							keys[this.document_page - 1]
						].items[keys_items[i]];
					this.items.push(item);
				}

				this.zone_extract = "";
				this.zones_extract_list = [""];
				var keys_zones = Object.keys(this.zones_extract);
				for (var i = 0; i < keys_zones.length; i++) {
					if (this.zones_extract[keys_zones[i]].attributes.nb_page == this.document_page)
						this.zones_extract_list.push(keys_zones[i]);
				}

				this.url_image =
					this.documents[this.document_name].pages[
						keys[this.document_page - 1]
					].url_image;

				this.image = "";
				if (this.url_image) {
					var image = await treatments.getFileAlyx(
						this.url_image,
						false,
						"arraybuffer"
					);
					this.image = this._arrayBufferToBase64(image);
				}

				this.reset();
			},
			document_name: async function () {
				this.change_document();
			},

		},
		methods: {
			async change_document()
			{
				this.documents_page = [];
				this.document_page = 1;
				var keys = Object.keys(
					this.documents[this.document_name].pages
				);
				for (var i = 0; i < keys.length; i++) {
					this.documents_page.push({value: i + 1, text: this.documents[this.document_name].pages[keys[i]].current_page + (this.documents[this.document_name].pages[keys[i]].rotate ? " - rotation : " + this.documents[this.document_name].pages[keys[i]].rotate : "" )});
				}

				var keys = Object.keys(
					this.documents[this.document_name].pages
				);
				this.page = this.document_page - 1;
				this.items = [];

				var keys_items = Object.keys(this.documents[this.document_name].pages[keys[this.document_page - 1]].items);
				for (var i = 0; i < keys_items.length; i++) 
				{
					var item = this.documents[this.document_name].pages[keys[this.document_page - 1]].items[keys_items[i]];
					this.items.push(item);
				}

				this.styles = this.documents[this.document_name].styles;
				this.url_pdf = this.documents[this.document_name].pages[keys[this.document_page - 1]].url_pdf || "";
				this.url_image = this.documents[this.document_name].pages[keys[this.document_page - 1]].url_image;

				this.zone_extract = "";
				this.zones_extract = {};
			
				this.image = "";
				if (this.url_image) 
				{
					var image = await treatments.getFileAlyx(this.url_image, false, "arraybuffer");
					this.image = this._arrayBufferToBase64(image);
				}

				this.reset();
			},
			select_file(files, column)
			{
				console.log(files)
				var arr = []
				for (var i = 0; i < files.length; i++)
				{
					arr.push(files[i].libelle.replace(/\.[^/.]+$/g, ""))
				}
				column.files = files;
				column.value = arr;
			},
			set_mapping_columns()
			{
				var modifications = false;

				var params = {
					"type": "line",
					"code": "",
					"strict": false,
					"cut_start": false,
					"cut_end": false
				};

				for (var i = 0; i < this.mapping_columns.length; i++)
				{
					if (this.mapping_columns[i].colonne && !this.mapping_columns[i].mapping)
					{
						modifications = true;
						params.code += "if (data.hasOwnProperty(`" + this.mapping_columns[i].colonne + "`)) { delete data[`" + this.mapping_columns[i].colonne + "`]; } \n";
					}
					else if (this.mapping_columns[i].text)
					{
						modifications = true;
						params.code += "data[`" + this.mapping_columns[i].mapping + "`] = `" + this.mapping_columns[i].text + "`; \n"
					}
					else if (this.mapping_columns[i].colonne && this.mapping_columns[i].mapping && this.mapping_columns[i].colonne != this.mapping_columns[i].mapping)
					{
						modifications = true;
						params.code += "if (data.hasOwnProperty(`" + this.mapping_columns[i].colonne + "`)) { \n"
						params.code += "data[`" + this.mapping_columns[i].mapping + "`] = data[`" + this.mapping_columns[i].colonne + "`]; \n"
						params.code += "delete data[`" + this.mapping_columns[i].colonne + "`]; \n } \n";
					}
				}

				if (modifications)
				{
					if (!this.scenario.existStepByDescription("Mapping"))
					{
						this.scenario.addStep({
							"data": {
								"parameters": params,
								"action": "fonction",
								"label": "Mapping",
								"sql_rules": ""
							},
							"description": "Mapping",
							"action": "fonction",
							"actionLabel": "Script personnalisé",
							"c_conditions": true,
							"c_tree": false,
							"c_project": false,
							"project_id": "",
							"c_parameters": true,
							"c_tabulator": false,
							"c_test": true,
							"tabulator2": [],
							"keep_start_data": false,
							"option_delete": false,
							"option_make_list": false,
							"treatment": false,
							"source_data": "",
							"file_result": false,
							"currentRequest": null,
							"user_params": []
						}, null, ["Analyse pdf - ", "Post t - "]);
					}
					else
					{
						this.scenario.updateStepParametersByDescription("Mapping", params);
					}
				}
				else
				{
					this.scenario.deleteStepByDescription("mapping");
				}
			},
			add_columns(arr)
			{
				if (arr.length == 0)
					return arr;

				var line = arr[0];
				var keys = Object.keys(line);

				for (var j = 0; j < this.mapping_columns.length; j++)
				{
					this.mapping_columns[j].exemple = "";
				}

				for (var i = 0; i < keys.length; i++)
				{
					var c = true;
					for (var j = 0; j < this.mapping_columns.length; j++)
					{
						if (keys[i] == this.mapping_columns[j].colonne)
						{
							this.mapping_columns[j].exemple = line[keys[i]];
							c = false;
							break;
						}
					}
					if (c)
					{
						this.mapping_columns.push({
							"colonne": keys[i],
							"mapping": keys[i],
							"exemple": line[keys[i]],
							"text": ""
						})
					}
				}
			},
			remove_mapping(idx)
			{
				this.mapping_columns.splice(idx, 1);
			},
			add_mapping()
			{
				this.mapping_columns.push({
					"colonne": "",
					"mapping": "",
					"exemple": "",
					"text": ""
				})
			},
			remove_column(idx)
			{
				this.columns.splice(idx, 1);
			},
			change_type_column: function(idx) 
			{
				var type_column = this.columns[idx].type_column;

				for (var i = 0; i < this.document_extraction.length; i++)
				{
					if (type_column == this.document_extraction[i].value)
					{
						this.columns[idx].type = this.document_extraction[i].type;
					}
				}
			},
			add_column: function(type_column)
			{
				var column = {
					column: "",
					type: "",
					value: ""
				};

				var obj = null;

				if (type_column)
				{
					this.type_column = type_column;
				}

				console.log("add_column")
				console.log(this.type_column)

				if (this.type_column)
				{
					for (var i = 0; i < this.document_extraction.length; i++)
					{
						if (this.type_column == this.document_extraction[i].value)
							obj = this.document_extraction[i];
					}
				}

				if (obj)
				{
					column = {
						column: obj.column,
						type: obj.type,
						type_column: this.type_column,
						value: ""
					}
				}

				this.columns.push(column);
				this.type_column = "";
			},
			_arrayBufferToBase64(buffer) {
				var binary = "";
				var bytes = new Uint8Array(buffer);
				var len = bytes.byteLength;
				for (var i = 0; i < len; i++) {
					binary += String.fromCharCode(bytes[i]);
				}
				return window.btoa(binary);
			},
			async get_tree_node(zones, child_zones) {
				for (var i = 0; i < child_zones.length; i++) {
					var zone = await this.$refs[
						"document_extraction_zone" + child_zones[i].id
					][0].save();
					zone.id = child_zones[i].id;
					zone.level = child_zones[i].level;
					zone.zones = [];
					if (child_zones[i].zones.length > 0)
						await this.get_tree_node(
							zone.zones,
							child_zones[i].zones
						);
					zones.push(zone);
				}
			},
			async get_tree() {
				var zones = [];

				for (var i = 0; i < this.zones.length; i++) {
					if (this.zones[i].level == 0) {
						var zone = await this.$refs[
							"document_extraction_zone" + this.zones[i].id
						][0].save();
						zone.id = this.zones[i].id;
						zone.level = this.zones[i].level;
						zone.zones = [];
						if (this.zones[i].zones.length > 0)
							await this.get_tree_node(
								zone.zones,
								this.zones[i].zones
							);
						zones.push(zone);
					}
				}

				return zones;
			},
			async save() {
				var data = {
					zones: [],
					relative: this.relative,
					columns: this.columns
				};

				data.zones = await this.get_tree();

				data.mapping = this.mapping;
				data.mapping_columns = this.mapping_columns;

				data.document_extraction_post_treatment = await this.$refs.document_extraction_post_treatment.save();

				return data;
			},
			async load_zone(zones) {
				//console.log("load zones")
				//console.log(clone(zones))
				for (var i = 0; i < zones.length; i++) {
					var zone = {
						id: uniqueId(),
						name: zones[i].name,
						level: zones[i].level || 0,
						zones: zones[i].zones || [],
						parameters: zones[i].parameters || {},
						position: zones[i].position || null,
						position_parent: zones[i].position_parent || null,
						project_id: zones[i].project_id || "",
						project: zones[i].project || null,
						params: zones[i].params || null,
						load: true
					};
					this.zones.push(zone);
					zones[i] = zone;
					//zones[i].id = zone.id;
					if (zones[i].zones && zones[i].zones.length > 0)
						this.load_zone(zones[i].zones);
				}
			},
			async load(data) {
				var self = this;
				this.zones = [];

				var zones = [];
				await this.load_zone(data.zones);

				console.log("load page")
				console.log(clone(this.zones))

				this.relative = data.relative || false;

				this.view_zones = this.zones[0].id;
				this.name_zone = this.zones[0].name;

				//console.log("data.columns")
				//console.log(JSON.stringify(data.columns))

				var columns = clone(data.columns);

				this.columns = data.columns || [];

				this.mapping = data.mapping || false;
				this.mapping_columns = data.mapping_columns || [];

				if (data.document_extraction_post_treatment)
					await this.$refs.document_extraction_post_treatment.load(data.document_extraction_post_treatment);

				self.$nextTick(async function () {

					console.log("load page 1")
					console.log(clone(self.zones))

					for (var i = 0; i < self.zones.length; i++) {
						await self.$refs[
							"document_extraction_zone" + self.zones[i].id
						][0].load(self.zones[i]);
					}

					console.log("load page 2")
					console.log(clone(self.zones))

					for (var i = 0; i < self.columns.length; i++)
					{
						self.columns[i].value = columns[i].value;
						if (columns[i].files)
						{
							self.$refs["documents-" + i][0].load_data_files_desc(columns[i].files);
						}
					}

					console.log("load page 3")
					console.log(clone(self.zones))
				});
			},
			async update_node(id, data, zones) {
				for (var i = 0; i < zones.length; i++) {
					if (zones[i].id == id) {
						zones[i].name = data.name;
						(this.name_zone = data.name),
							this.$set(zones, i, zones[i]);
						if (zones[i].zones.length > 0)
							await this.update_node(id, data, zones.zones);
					}
				}
			},
			async update(id, data) {
				for (var i = 0; i < this.zones.length; i++) {
					if (this.zones[i].id == id) {
						this.zones[i].name = data.name;
						this.zones[i].parameters = data;
						(this.name_zone = data.name),
							this.$set(this.zones, i, this.zones[i]);
					}
					if (this.zones[i].zones && this.zones[i].zones.length > 0)
						await this.update_node(id, data, this.zones[i].zones);
				}
				var zones = await this.get_tree();
				this.$emit("update", zones);
			},
			update_name(new_name) {
				var params =
					this.$refs[
						"document_extraction_zone" + this.view_zones
					][0].getParams();
				params.name = new_name;
				this.$refs[
					"document_extraction_zone" + this.view_zones
				][0].setParams(params);
			},
			select(id) {
				this.view_zones = id;
			},
			setDocuments: function (documents) {
				this.documents = documents;
				this.documents_name = Object.keys(this.documents);
				if (!this.document_name && this.documents_name.length > 0)
					this.document_name = this.documents_name[0];

				this.change_document();
			},
			addZoneTree(zones, zone_add, ids) {
				var id = ids.shift();
				var zone = null;
				for (var i = 0; i < zones.length; i++) {
					if (zones[i].id == id) {
						zone = zones[i];
						break;
					}
				}
				if (ids.length > 0) {
					this.addZoneTree(zone.zones, zone_add, ids);
				} else {
					zone_add.position = zone.position || null;
					zone_add.position_parent = zone.position || null;
					if (!zone_add.parameters)
					{
						zone_add.parameters = {
							options: {}
						}
					}
					zone_add.parameters.options.condition_page = zone.parameters.options.condition_page;
					if (zone.parameters.options.condition_rotation || zone.parameters.options.condition_rotation == 0)
						zone_add.parameters.options.condition_rotation = zone.parameters.options.condition_rotation;
					zone.zones.push(zone_add);
				}
			},
			addZone: async function (level = 0, ids = []) {
				var zone = {
					id: uniqueId(""),
					zones: [],
					level: level,
				};
				this.zones.push(zone);
				this.view_zones = this.zones[this.zones.length - 1].id;
				this.name_zone = this.zones[this.zones.length - 1].name;
				if (ids.length > 0) {
					this.addZoneTree(this.zones, zone, ids);
				}
			},
			removeZone(zones, ids, id, remove) {
				for (var i = 0; i < zones.length; i++) {
					if (zones[i].zones.length > 0) {
						if (zones[i].id == id)
							this.removeZone(zones[i].zones, ids, id, true);
						else this.removeZone(zones[i].zones, ids, id, remove);
					}
					if (zones[i].id == id || remove) {
						ids.push(zones[i].id);
						if (zones[i].level) {
							zones.splice(i, 1);
							i--;
						}
					}
				}
			},
			async removeAt(idx) {
				var zone = this.zones[idx];
				var ids = [];

				this.removeZone(this.zones, ids, zone.id, false);

				for (var i = 0; i < this.zones.length; i++) {
					if (ids.includes(this.zones[i].id)) {
						this.zones.splice(i, 1);
						i--;
					}
				}
				if (this.zones.length > 0) {
					this.view_zones = this.zones[this.zones.length - 1].id;
					this.name_zone = this.zones[this.zones.length - 1].name;
				}
				var zones = await this.get_tree();
				this.$emit("update", zones);
			},
			set_zones_extract(zones_extract, level, prefix) {
				var keys = Object.keys(zones_extract);
				for (var i = 0; i < keys.length; i++) {
					if (level > 0) {
						this.zones_extract[prefix + "-" + keys[i]] =
							zones_extract[keys[i]];
					}
					if (zones_extract[keys[i]].zones) {
						this.set_zones_extract(
							zones_extract[keys[i]].zones,
							level + 1,
							prefix ? prefix + "-" + keys[i] : keys[i]
						);
					}
				}
			},
			async test_project(
				project,
				formData,
				tags,
				results_files,
				name_file,
				first_csv,
				urls,
				nb_step, 
				step,
				params,
				treatment_params,
				step_uid
			) {
				var results = []
				var tag_data = {};
				if (project.tags && tags) {
					for (var i = 0; i < project.tags.length; i++) {
						if (project.tags[i].tag == tags)
							tag_data = project.tags[i];
					}
				}
				var treatment_data = await treatments.create(
					project.uid,
					null,
					null,
					null,
					[tags],
					tag_data.type_import || "import",
					formData,
					params,
					treatment_params,
					step_uid
				).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });

				while (
					treatment_data.treatment.resultat != "ok" &&
					treatment_data.treatment.resultat != "ko"
				) {
					await new Promise((resolve) => setTimeout(resolve, 2000));
					treatment_data = await treatments.get(
						treatment_data.treatment.uid
					);
				}
				var all_files = await treatments.getFiles(
					treatment_data.treatment.uid
				);
				if (!all_files || all_files.length == 0) all_files = [];
				all_files.sort((a, b) =>
					a.nom_fichier > b.nom_fichier ? 1 : -1
				);
				var export_type = tag_data.type_export || "export";
				for (var i = 0; i < all_files.length; i++) {
					if (nb_step <= 1) {
						if (
							first_csv &&
							all_files[i].type == export_type &&
							all_files[i].nom_fichier.endsWith(".csv") &&
							!step.file_result
						) {
							var csv_data = await treatments.getFile(
								all_files[i].uid,
								all_files[i].nom_fichier,
								false,
								false
							);
							name_file = all_files[i].nom_fichier;
							results = this.$papa.parse(csv_data, {
								header: true,
							});
							results = results.data;
							first_csv = false;
						} else if (all_files[i].type == export_type) {
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
						}
					} else {
						if (all_files[i].type == export_type)
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
					}
				}

				return { name_file, first_csv, urls, results };
			},
			get_project(uid) {

				// console.log(this.project_id)
				for (var i = 0; i < this.projects.length; i++) {
					if (this.projects[i].uid == uid) {
						return this.projects[i];
					}
				}
			},
			async test_steps()
			{
				console.log("test_steps")
				var self = this;
				
				this.spinner = true;
				this.$refs.edit_tabulator_test.set_data(this.results_arr);
				var steps = await this.scenario.getStepsByDescription("");

				this.test_logs = [];

				var results = []

				let files = await this.$refs.edit_tabulator_test.get_data_files();
				let urls_files = []

				this.test_logs.push("Début du traitement");
				for (var i = 0; i < steps.length; i++)
				{
					console.log(" --- ")
					console.log(steps[i]);

					if (steps[i].description != "ocr" && !steps[i].description.startsWith("Analyse pdf - "))
					{
						console.log("start " + steps[i].description);
						console.log(files)
						console.log(urls_files)

						this.test_logs.push("Début de l'étape " + steps[i].description);
						
						var stop = await this.scenario.test(steps[i].step, steps[i].step.getUid(), steps[i].step.get_params_data(), false, false, steps[i].step.get_treatment(), 2, files, urls_files)

						console.log(stop)

						urls_files = await steps[i].step.getUrls();

						console.log(files);

						if (urls_files && urls_files.length > 0 && urls_files[0].name.endsWith(".csv"))
						{
							var csv_data = await treatments.getFileAlyx(
								urls_files[0].url,
								false,
								false
							);
							var results = this.$papa.parse(csv_data, {
								header: true,
							});
							results = results.data;

							this.$refs.edit_tabulator_test.set_data(results);
						}

						files = null;

						this.test_logs.push("Fin de l'étape " + steps[i].description);

						await new Promise((resolve, reject) => {
							self.$nextTick(async function () {
								resolve();
							});
						});

						console.log("end " + steps[i].description);

						if (stop)
							break;
					}
				}

				this.test_logs.push("Fin du traitement");
				this.spinner = false;
			},
			async test_post_treatment()
			{
				var self = this;
				
				this.spinner = true;
				this.$refs.edit_tabulator_post_t.set_data(this.results_arr);
				var steps = await this.scenario.getStepsByDescription("Post t - ");
				this.post_treatment_logs = [];

				var results = []

				this.post_treatment_logs.push("Début des post traitements");
				for (var i = 0; i < steps.length; i++)
				{
					console.log(steps[i]);
					this.post_treatment_logs.push("Début du post traitement pour " + steps[i].data.parameters.params.column);

					let formData = new FormData();
					//console.log(await this.$refs.edit_tabulator_post_t.get_data())
					let files = await this.$refs.edit_tabulator_post_t.get_data_files();
					formData.append(files[0].name, files[0]);

					let project = this.get_project(steps[i].data.parameters.project);
					let resp = await this.test_project(
						project,
						formData,
						steps[i].data.parameters.tags,
						[],
						"",
						true,
						[],
						0,
						{},
						steps[i].data.parameters,
						[],
						uniqueId()
					);

					console.log(resp.results)

					results = resp.results;

					this.$refs.edit_tabulator_post_t.set_data(resp.results);

					this.post_treatment_logs.push("Fin du post traitement pour " + steps[i].data.parameters.params.column);

					await new Promise((resolve, reject) => {
						self.$nextTick(async function () {
							resolve();
						});
					});
				}
				
				this.add_columns(results);

				this.post_treatment_logs.push("Fin des post traitements");
				this.spinner = false;
			},
			async test_file() {
				this.spinner = true;
				var zones = await this.get_tree();
				var data = {
					action: "zone_extract",
					parameters: {
						json: true,
						name: this.name,
						params: zones,
						url_pdf: this.url_pdf,
						data: this.documents[this.document_name],
					},
				};
				this.results_test = await workers.test(data);

				console.log(this.results_test)

				var keys = Object.keys(this.results_test.data.json);
				this.zones_extract = {};
				for (var i = 0; i < keys.length; i++)
				{ 
					var keys_zones = Object.keys(this.results_test.data.json[keys[i]].zones);
					for (var j = 0; j < keys_zones.length; j++)
					{
						this.zones_extract[this.results_test.data.json[keys[i]].zones[keys_zones[j]].attributes.nb_page + " - " + keys_zones[j]] = this.results_test.data.json[keys[i]].zones[keys_zones[j]];
					}
				}

				var data = {
					action: "zone_final_extract",
					parameters: {
						json: true,
						data: this.results_test.data.json,
						column_name: this.column_name,
						inter_page: this.inter_page
					},
				};

				this.results_test = await workers.test(data);

				for (var i = 0; i < this.results_test.data.json.length; i++)
				{
					for (var j = 0; j < this.columns.length; j++)
					{
						this.results_test.data.json[i][this.columns[j].column] = this.columns[j].value;
					}
				}
								
				this.$refs.edit_tabulator_global.set_data(
					this.results_test.data.json
				);
				this.results_arr = this.results_test.data.json;
				this.$refs.edit_tabulator_post_t.set_data(this.results_arr);

				await this.set_zones_extract_test();
				this.add_columns(this.results_arr);

				this.spinner = false;
			},
			test: async function () {
				this.spinner = true;
				var zones = await this.get_tree();
				var data = {
					action: "zone_extract",
					parameters: {
						json: true,
						name: this.name,
						params: zones,
						page: this.page_obj.current_page,
						rotate: this.page_obj.rotate,
						url_pdf: this.url_pdf,
						styles: this.styles,
						items: this.items,
					},
				};

				this.results = await workers.test(data);

				console.log(this.results)

				var keys = Object.keys(this.results.data.json);
				this.zones_extract = this.results.data.json[keys[0]].zones;

				var data = {
					action: "zone_final_extract",
					parameters: {
						json: true,
						data: this.results.data.json,
						column_name: this.column_name,
						inter_page: this.inter_page
					},
				};

				this.results = await workers.test(data);

				console.log(this.results)

				for (var i = 0; i < this.results.data.json.length; i++)
				{
					for (var j = 0; j < this.columns.length; j++)
					{
						this.results.data.json[i][this.columns[j].column] = this.columns[j].value;
					}
				}

				this.$refs.edit_tabulator.set_data(this.results.data.json);
				this.results_arr = this.results.data.json;

				console.log(this.columns)
				this.$refs.edit_tabulator_post_t.set_data(this.results_arr);

				await this.set_zones_extract_test();

				this.add_columns(this.results_arr);
				this.spinner = false;
			},
			async set_zones_extract_test()
			{
				this.set_zones_extract(this.zones_extract, 0, "");

				this.zones_extract_list = [""];
				var keys = Object.keys(this.zones_extract);
				for (var i = 0; i < keys.length; i++) {
					if (this.zones_extract[keys[i]].attributes.nb_page == this.document_page)
						this.zones_extract_list.push(keys[i]);

					if (
						this.zones_extract[keys[i]].position_absolute.top ==
							null ||
						this.zones_extract[keys[i]].position_absolute.top < 0
					)
						this.zones_extract[keys[i]].position_absolute.top = 0;
					if (
						this.zones_extract[keys[i]].position_absolute.left ==
							null ||
						this.zones_extract[keys[i]].position_absolute.left < 0
					)
						this.zones_extract[keys[i]].position_absolute.left = 0;
					if (
						this.zones_extract[keys[i]].position_absolute.bottom ==
							null ||
						this.zones_extract[keys[i]].position_absolute.bottom >
							10000
					)
						this.zones_extract[
							keys[i]
						].position_absolute.bottom = 10000;
					if (
						this.zones_extract[keys[i]].position_absolute.right ==
							null ||
						this.zones_extract[keys[i]].position_absolute.right >
							10000
					)
						this.zones_extract[
							keys[i]
						].position_absolute.right = 10000;
					this.zones_extract[keys[i]].position_absolute.height =
						this.zones_extract[keys[i]].position_absolute.bottom -
						this.zones_extract[keys[i]].position_absolute.top;
					this.zones_extract[keys[i]].position_absolute.width =
						this.zones_extract[keys[i]].position_absolute.right -
						this.zones_extract[keys[i]].position_absolute.left;
				}

				await this.set_positions(this.zones, "", null);

				if (!this.zones_extract_list.includes(this.zone_extract))
					this.zone_extract = "";
			},
			async set_positions(zones, parent, position_parent, condition_page = null, condition_rotation = null) {
				for (var i = 0; i < zones.length; i++) {
					var name = parent + (parent ? "-" : "") + zones[i].name;
					if (this.zones_extract[name]) {
						zones[i].position =
							this.zones_extract[name].position_absolute;
						zones[i].position_parent = position_parent;
						if (condition_page !== null)
							zones[i].parameters.options.condition_page = condition_page;
						if (condition_rotation !== null)
							zones[i].parameters.options.condition_rotation = condition_rotation;
						this.$refs[
							"document_extraction_zone" + zones[i].id
						][0].setPosition(
							zones[i].position,
							zones[i].position_parent
						);
						if (zones[i].zones) {
							await this.set_positions(
								zones[i].zones,
								name,
								zones[i].position,
								zones[i].parameters.options.condition_page,
								zones[i].parameters.options.condition_rotation
							);
						}
					}
				}
			},
			addLimit: function (limit) {
				this.$refs[
					"document_extraction_zone" + this.view_zones
				][0].addLimit(limit);
			},
			addClass: function (e) {
				this.target = e.target.id;
				e.target.classList.add("hovered");
			},
			removeClass: function (e) {
				this.target = -1;
				e.target.classList.remove("hovered");
			},
			setMeta(name, page, url_pdf, rotate) {
				this.name = name;
				this.page = page;
				this.url_pdf = url_pdf || "";
				this.rotate = rotate || 0;
			},
			setItems(items) {
				this.items = items;
			},
			setStyle(styles) {
				this.styles = styles;
			},
			handler_up: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				var x = Math.round(left);
				if (this.relative && this.zone.position_parent)
					x -= this.zone.position_parent.left;
				var y = Math.round(top);
				if (this.relative && this.zone.position_parent)
					y -= this.zone.position_parent.top;

				if (x != this.x && y != this.y) {
					var x1 = 0;
					var x2 = 0;
					var y1 = 0;
					var y2 = 0;
					if (this.x > x) {
						x1 = x;
						x2 = this.x;
					} else {
						x1 = this.x;
						x2 = x;
					}
					if (this.y > y) {
						y1 = y;
						y2 = this.y;
					} else {
						y1 = this.y;
						y2 = y;
					}
					this.addLimit({
						type: "block",
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						relative: this.relative,
					});
				}
				this.move = false;
			},
			handler_move: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.actual_x = Math.round(left);
				this.abs_actual_x = this.actual_x;
				if (this.relative && this.zone.position_parent)
					this.actual_x -= this.zone.position_parent.left;
				this.actual_y = Math.round(top);
				this.abs_actual_y = this.actual_y;
				if (this.relative && this.zone.position_parent)
					this.actual_y -= this.zone.position_parent.top;
			},
			handler: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.x = Math.round(left);
				this.abs_x = this.x;
				if (this.relative && this.zone.position_parent)
					this.x -= this.zone.position_parent.left;
				this.y = Math.round(top);
				this.abs_y = this.y;
				if (this.relative && this.zone.position_parent)
					this.y -= this.zone.position_parent.top;
				if (this.e) this.e.target.classList.remove("selected");
				if (this.target > -1) {
					this.item = this.items[this.target];
					this.e = e;
					e.target.classList.add("selected");
				} else {
					this.e = null;
					this.item = null;
				}

				this.move = true;
			},
			reset() {
				this.panzoomInstance.zoomAbs(0, 0, 1);
				this.panzoomInstance.moveTo(0, 0);
			},
			onInit: function (panzoomInstance, id) {
				this.panzoomInstance = panzoomInstance;
				//this.panzoomInstance.zoomTo(0, 0, 2);
			},
			onResize() {
				if (this.$refs.div_row)
					this.size =
						this.$refs.div_row.clientWidth -
						this.$refs.div_menu.clientWidth;
			},
		},
		mounted: async function () {
			var self = this;

			this.view_zones = this.zones[0].id;
			this.name = this.zones[0].name;

			this.ro = new ResizeObserver(this.onResize).observe(
				this.$refs.div_row
			);

			self.$nextTick(function () {
				self.size =
					self.$refs.div_row.clientWidth -
					self.$refs.div_menu.clientWidth;
			});

			console.log("document_extraction")
			if (this.document_extraction)
			{
				console.log("document_extraction")
				console.log(this.document_extraction)
				for (var i = 0; i < this.document_extraction.length; i++)
				{
					console.log(this.document_extraction[i])
					if (this.document_extraction[i].start)
						this.add_column(this.document_extraction[i].value)
				}
			}

		},
	};
</script>

<style>
	.hovered {
		text-decoration: underline blue;
		cursor: crosshair;
	}
	.selected {
		text-decoration: underline red;
		cursor: crosshair;
	}
</style>
